<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-9">
      <v-form v-model="valid" class="py-8">
        <v-card class="ImgeUploader px-4" color="transparent" flat>
          <span
            style="
              font-size: 12px;
              font-weight: 400;
              color: rgba(8, 8, 22, 0.38);
            "
          >
            Video thumbnail should be "500x300px"
          </span>
          <video-image-uploader-component
            @uploadImg="uploadImg"
            :thumbnil="selectedImage"
          />
        </v-card>

        <div class="ma-4">
          <v-text-field
            v-model="rowData.Title"
            :error-messages="
              $v.rowData.Title.$error ? 'Title is required' : null
            "
            label="Title"
            required
          ></v-text-field>
          <v-select
            v-model="rowData.CategoryId"
            :error-messages="
              $v.rowData.CategoryId.$error ? 'Category is required' : null
            "
            :items="GetVideosCategory"
            label="Category"
            attach
            item-text="Name"
            item-value="Id"
          ></v-select>
          <div class="d-flex justify-end">
            <v-dialog v-model="newcategorydialog" persistent max-width="450">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="text_style"
                >
                  + Create Category
                </v-btn>
              </template>
              <v-card>
                <div class="mx-5 py-5 d-flex justify-space-between">
                  <h5 class="text_style">New Category</h5>
                  <v-icon @click="newcategorydialog = false">mdi-close</v-icon>
                </div>
                <v-card color="#F6F8FC" flat class="py-5 px-3 my-8">
                  <v-text-field
                    :error-messages="
                      $v.form.Name.$error ? 'Name is required' : null
                    "
                    v-model="form.Name"
                    label="Name Category"
                    required
                  ></v-text-field>
                </v-card>
                <v-card-actions class="pb-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey lighten-1"
                    text
                    @click="newcategorydialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :disabled="disabledSavebtn"
                    color="primary"
                    @click="send()"
                  >
                    <v-progress-circular
                      indeterminate
                      size="20"
                      class="px-5"
                      color="white"
                      v-show="btnCategoryloader"
                    ></v-progress-circular>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-text-field
            v-model="rowData.DisplayOrder"
            :error-messages="
              $v.rowData.DisplayOrder.$error
                ? 'Display Order is required'
                : null
            "
            label=" Display Order"
            type="number"
          ></v-text-field>
          <v-select
            v-model="rowData.SubmittedBy"
            :error-messages="
              $v.rowData.SubmittedBy.$error ? 'Submitted By is required' : null
            "
            :items="GetSiteUser"
            item-text="FirstName"
            item-value="Id"
            placeholder="Submitted by"
            label="Submitted by"
            attach
            :menu-props="{ maxHeight: '400px' }"
          ></v-select>
          <v-select
            v-model="rowData.Modality"
            :error-messages="
              $v.rowData.Modality.$error ? 'Modality is required' : null
            "
            :items="category"
            label="Modality"
            attach
            :menu-props="{ maxHeight: '400px' }"
          ></v-select>
          <v-textarea
            v-model="rowData.Description"
            :error-messages="
              $v.rowData.Description.$error ? 'Description is required' : null
            "
            label="Description"
            counter
            maxlength="300"
            full-width
            single-line
          ></v-textarea>
          <div class="mt-5 mb-3"><span>Permissions</span></div>
          <v-select
            v-model="rowData.MembershipType"
            :error-messages="
              $v.rowData.MembershipType.$error
                ? 'Membership Type is required'
                : null
            "
            label="Membership Type"
            attach
            :items="PermissionMembership"
            multiple
            :menu-props="{ maxHeight: '400px' }"
          >
          </v-select>
          <v-select
            v-model="rowData.CoursePrerequisites"
            :error-messages="
              $v.rowData.CoursePrerequisites.$error
                ? 'Course Prerequisites is required'
                : null
            "
            clearable
            :items="modifiedCoursesArray"
            item-text="Title"
            item-value="Id"
            label="Course Prerequisites"
            attach
          ></v-select>
          <v-select
            v-model="rowData.PractionerLevel"
            :error-messages="
              $v.rowData.PractionerLevel.$error
                ? 'Credentials is required'
                : null
            "
            :items="Credentials"
            label="Credentials"
            attach
            :menu-props="{ maxHeight: '400px' }"
          ></v-select>
          <v-select
            v-model="rowData.CourseInstructorTaught"
            :error-messages="
              $v.rowData.CourseInstructorTaught.$error
                ? 'Course Instructor is required'
                : null
            "
            item-text="Name"
            item-value="Id"
            clearable
            :items="modifiedInstructorsArray"
            label="Instructor-Courses Taught"
            attach
          ></v-select>
          <v-select
            v-model="rowData.Language"
            :error-messages="
              $v.rowData.Language.$error ? 'Language is required' : null
            "
            :items="languages"
            label="Language"
            attach
          ></v-select>

          <v-radio-group v-model="radios" mandatory row>
            <div class="d-flex justify-start">
              <v-radio
                key="uploadvideoradio"
                value="uploadvideoradio"
                color="#ECA615"
              ></v-radio>
              <span>Upload video</span>
            </div>
            <div class="d-flex justify-start ml-9">
              <v-radio
                key="localuploadradio"
                value="localuploadradio"
                color="#ECA615"
              ></v-radio>
              <span>Video URL link</span>
            </div>
          </v-radio-group>
          <div v-if="radios == 'uploadvideoradio'">
            <!-- <v-progress-circular
              indeterminate
              color="#ECA615"
              :width="3"
            ></v-progress-circular> -->
            <v-row>
              <v-col md="5" sm="12">
                <v-btn
                  class="text_style my-4 px-11"
                  color="primary"
                  outlined
                  @click="onButtonClick"
                  >Upload File</v-btn
                >
                <input
                  ref="uploader"
                  class="d-none"
                  type="file"
                  @change="onFileChanged"
                />
              </v-col>
              <v-col md="7" sm="12">
                <div
                  v-if="UploadedfileName"
                  class="d-flex align-center"
                  style="height: 100%"
                >
                  <v-chip
                    color="primary"
                    @click:close="closechip()"
                    close
                    outlined
                    v-show="chip1 || UploadedfileName"
                    pill
                    ><span class="text_elispis">{{
                      this.UploadedfileName.substring(0,32)
                    }}</span>
                  </v-chip>
                </div></v-col
              >
            </v-row>
          </div>
          <div v-if="radios == 'localuploadradio'">
            <v-text-field v-model="vedioUrl"></v-text-field>
            <div v-if="vedioUrl">
              <iframe
                :src="embedUrl"
                height="300"
                width="500"
                frameborder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </v-form>
    </v-card>
    <div class="mx-5 px-9 py-5 d-flex justify-end">
      <v-btn
        class="px-14 py-5"
        color="transparent"
        depressed
        @click="closeDialog"
        ><span class="text_style">Cancel</span></v-btn
      >
      <v-btn
        color="primary"
        class="px-14 py-6 text_style"
        @click="handleFileUpload()"
        :disabled="disabledSave"
      >
        <span class="pa-4 text_style" v-if="btnloader !== true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </div>
</template>

<script>
import VideoImageUploaderComponent from "./VideoImageUploader.component.vue";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "AddNewVideoComponent",
  props: {
    selectedRowData: {
      type: Object,
      default: () => ({}),
    },
    editDialog: {
      type: Boolean,
    },
    selectedImage: {
      type: String,
    },
  },
  computed: {
    ...mapGetters([
      "GetVideosCategory",
      "GetSiteUser",
      "getMembership",
      "GetCoursesIDsAndTitle",
      "GetAllInstructorsIDsAndNames",
    ]),
    modifiedInstructorsArray() {
      const noneOption = { Name: "None", Id: 0 };
      return [noneOption, ...this.GetAllInstructorsIDsAndNames];
    },
    modifiedCoursesArray() {
      const noneOption = { Title: "None", Id: 0 };
      return [noneOption, ...this.GetCoursesIDsAndTitle];
    },
    modifiedMembershipArray() {
      const noneOption = { Name: "None", Id: 0 };
      return [noneOption, ...this.getMembership];
    },
  },
  components: {
    VideoImageUploaderComponent,
  },

  mounted() {
    if (this.editDialog) {
      this.rowData = {
        ...this.selectedRowData,
        CoursePrerequisites: Number(this.selectedRowData.CoursePrerequisites),
        CourseInstructorTaught: Number(
          this.selectedRowData.CourseInstructorTaught
        ),
        PractionerLevel: this.selectedRowData.PractionerLevel,
        // MembershipType: Number(this.selectedRowData.MembershipType),
        SubmittedBy: Number(this.selectedRowData.SubmittedBy),
        DisplayOrder: this.selectedRowData.DisplayOrder,
        ThumbnailImage: this.selectedRowData.ThumbnailImage,
        MembershipType:this.selectedRowData.MembershipType.split(",")
      };
      if (this.selectedRowData && this.selectedRowData.VideoUrl) {
        const index = this.selectedRowData.VideoUrl.indexOf("_");
        this.UploadedfileName = this.selectedRowData.VideoUrl.substring(
          index + 1
        );
        this.radios == "uploadvideoradio";
      }
    }
  this.fetchData()
  },
  data() {
    return {
      categoryOptions: [],
      SubmittedBy: null,
      vedioText: "",
      vedioUrl: "",
      languages: [
        "English",
        "French",
        "German",
        "Japanese",
        "Portuguese",
        "Filipino",
      ],
      PermissionMembership: [
        "None",
        "Starter",
        "Access",
        "Standard",
        "Practitioner",
        "Instructor",
        "LifeScience",
        "Deceased",
        "InActive",
        "Trainee Instructor",
        "Senior Instructor",
      ], 
      isSelecting: false,
      uploadoption1: false,
      btnloader: false,
      btnCategoryloader: false,
      disabledSave: false,
      showFileError: false,
      disabledSavebtn: false,
      radios: "",
      rowData: {},
      switchMe: false,
      newcategorydialog: false,
      selectedFile: null,
      UploadedfileName: "",
      chip1: false,
      valid: false,
      firstname: "",
      lastname: "",
      embedUrl: "",
      // nameRules: [
      //   (v) => !!v || "Name is required",
      //   (v) => v.length <= 10 || "Name must be less than 10 characters",
      // ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],

      Credentials: [
        "None",
        "CBP",
        "CBP-A",
        "AdvCBP",
        "PaRamaCBP",
        "BAT",
        "CBI",
      ],
      category: [
        "BodyTalk",
        "BodyTalk for Animals",
        "BodyTalk Access",
        "MindScape",
        "BreakThrough",
        "FreeFall",
        "PaRama",
      ],
      form: {
        Name: "",
      },
    };
  },
  validations: {
    rowData: {
      Title: {
        required,
      },
      CategoryId: {
        required,
      },
      DisplayOrder: {
        required,
      },
      SubmittedBy: {
        required,
      },
      Modality: {
        required,
      },
      Description: {
        required,
      },
      MembershipType: {
        required,
      },
      CoursePrerequisites: {
        required,
      },
      PractionerLevel: {
        required,
      },
      CourseInstructorTaught: {
        required,
      },
      Language: {
        required,
      },
    },
    form: {
      Name: { required },
    },
  },
  watch: {
    radios(newValue) {
      if (newValue === "localuploadradio") {
        this.UploadedfileName = null;
        this.selectedFile = null;
      }
      if (newValue === "uploadvideoradio") {
        this.vedioUrl = "";
      }
    },
    vedioUrl: function (newVal) {
      this.embedUrl = this.convertToEmbedUrl(newVal);
    },
  },
  methods: {
    async fetchData(){
      this.GetSiteUser.length == 0 && await this.$store.dispatch("getSiteUser");
      this.GetCoursesIDsAndTitle.length == 0 && await this.$store.dispatch("GetCoursesIDsAndTitle");
      this.GetAllInstructorsIDsAndNames.length == 0 && await this.$store.dispatch("GetAllInstructorsIDsAndNames");
    },
    convertToEmbedUrl(watchUrl) {
      const isYouTubeUrl = watchUrl.includes("youtube.com");
      if (isYouTubeUrl) {
        const videoId = watchUrl.match(/(?:\?|&)v=([^&#]+)/)[1];
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;
        return embedUrl;
      } else {
        return watchUrl;
      }
    },
    uploadImg(src) {
      this.rowData.ThumbnailImage = src;
    },
    closeCategorydialog() {
      this.form.Name = "";
      this.$v.$reset();
    },
    close() {
      this.$emit("close");
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    closeDialog() {
      this.$emit("fetchVideosList");
      this.$emit("close");
      this.rowData = {};
      this.$v.$reset();
      this.selectedFile = null;
      this.UploadedfileName = "";
      this.vedioUrl = "";
    },
    closechip() {
      this.selectedFile = null;
      this.chip1 = false;
      this.showFileError = true;
      this.UploadedfileName = "";
    },
    snackbarClose() {
      this.snackbar = false;
    },
    onFileChanged(e) {
      this.chip1 = true;
      this.selectedFile = e.target.files[0];
      this.UploadedfileName = this.selectedFile.name;
      this.showFileError = false;
      this.$refs.uploader.value = null;
      //
      // do something
    },

    

    handleFileUpload() {
      this.$v.rowData.$touch();
      if (this.$v.rowData.$invalid) {
        return;
      } else {
        this.disabledSave = true;
        this.btnloader = true;
        const formData = new FormData();
        formData.append("Title", this.rowData.Title);
        formData.append("CategoryId", this.rowData.CategoryId);
        formData.append("DisplayOrder", this.rowData.DisplayOrder);
        formData.append("SubmittedBy", this.rowData.SubmittedBy);
        formData.append("Modality", this.rowData.Modality);
        formData.append("Description", this.rowData.Description);
        formData.append("MembershipType", this.rowData.MembershipType);
        if (this.editDialog) {
          formData.append("ThumbnailImage", this.rowData.ThumbnailImage.file);
        } else {
          formData.append(
            "ThumbnailImageUrl",
            this.rowData.ThumbnailImage.file ? "" : this.rowData.ThumbnailImage
          );
          formData.append(
            "ThumbnailImage",
            this.rowData.ThumbnailImage.file || ""
          );
        }
        formData.append(
          "CoursePrerequisites",
          this.rowData.CoursePrerequisites
        );
        formData.append("PractionerLevel", this.rowData.PractionerLevel);
        formData.append(
          "CourseInstructorTaught",
          this.rowData.CourseInstructorTaught
        );
        formData.append("Language", this.rowData.Language);

        if (this.radios === "uploadvideoradio") {
          formData.append("VideoFile", this.selectedFile);
        }
        if (this.radios === "localuploadradio") {
          formData.append("VideoUrl", this.vedioUrl);
        }
        // formData.append("SubmittedBy", this.SubmittedBy);
        if (this.editDialog) {
          formData.append("Id", this.rowData.Id);
        }
        this.$store
          .dispatch(
            `${this.editDialog ? "UpdateVideosList" : "CreateVideo"}`,
            formData
          )
          .then((res) => {
            this.disabledSave = false;
            this.btnloader = false;
            this.selectedFile = null;
            if (res.Status) {
              this.closeDialog();
              const toastMessage = this.editDialog ? "Edited Successfully" : "Added Successfully";
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: toastMessage,
                showConfirmButton: false,
                timer: 2500,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.disabledSave = false;
            this.btnloader = false;
          });
      }
    },
    showSuccessToast(message = "File has been saved") {
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon:
          message.includes("failed") || message.includes("error")
            ? "error"
            : "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    send() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      } else {
        this.btnCategoryloader = true;
        this.disabledSavebtn = true;
        this.$store
          .dispatch("CreateVideosCategory", { Name: this.form.Name })
          .then((res) => {
            this.disabledSavebtn = false;
            this.btnCategoryloader = false;
            if (res.Status) {
              this.rowData.CategoryId = res.Data.Id;
              this.$store.dispatch("GetVideosCategory");
              this.newcategorydialog = false;
              this.showSuccessToast("Group has been saved");
            } else {
              this.showSuccessToast(res.Message);
              this.btnCategoryloader = false;
              this.disabledSavebtn = false;
            }
          })
          .catch((res) => {
            this.showSuccessToast(res.message);
            this.btnCategoryloader = false;
            this.disabledSavebtn = false;
            this.newcategorydialog = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 0px;
}
.ImgeUploader {
  width: 100%;
}
@media screen and (max-width: 430px) {
  .ImgeUploader {
    width: 100%;
  }
}
</style>
